import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { Users, Check, X as XIcon } from "lucide-react";

const RSVPListCard = ({ eventId, allowRsvp }) => {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    try {
      const r = await api.get(`/events/${eventId}/rsvps`);
      setData(r.data);
    } catch {
      setData({ items: [], count: 0, attending_headcount: 0 });
    }
  }, [eventId]);

  useEffect(() => {
    if (allowRsvp) load();
  }, [allowRsvp, load]);

  if (!allowRsvp) {
    return (
      <div data-testid="rsvp-list-card-disabled" className="bg-white rounded-2xl soft-shadow p-6">
        <div className="flex items-center gap-2 mb-1">
          <Users className="w-4 h-4 text-coral-300" />
          <h3 className="font-serif italic text-navy-700 text-xl">RSVPs</h3>
        </div>
        <p className="text-sm text-navy-700/60">RSVPs are turned off for this event. Enable them in event settings when you create a Classic or Grand event.</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="bg-white rounded-2xl soft-shadow p-6 text-sm text-navy-700/60">Loading RSVPs…</div>
    );
  }

  return (
    <div data-testid="rsvp-list-card" className="bg-white rounded-2xl soft-shadow p-6">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Users className="w-4 h-4 text-coral-300" />
          <h3 className="font-serif italic text-navy-700 text-xl">RSVPs</h3>
        </div>
        <div className="text-sm text-navy-700/60">
          <b data-testid="rsvp-attending-headcount" className="text-navy-700">{data.attending_headcount}</b> attending · {data.count} total
        </div>
      </div>
      {data.items.length === 0 ? (
        <p className="text-sm text-navy-700/60">No RSVPs yet. Share your guest link to start collecting them.</p>
      ) : (
        <ul className="divide-y divide-cream-200 max-h-80 overflow-auto">
          {data.items.map(r => (
            <li key={r.id} className="py-2.5 flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="font-medium text-navy-700 truncate">{r.name}</span>
                  {r.plus_ones > 0 && <span className="text-xs bg-coral-100 text-coral-500 rounded-full px-2 py-0.5 font-semibold">+{r.plus_ones}</span>}
                </div>
                {r.email && <div className="text-xs text-navy-700/50 truncate">{r.email}</div>}
                {r.note && <div className="text-xs text-navy-700/70 mt-0.5 italic">“{r.note}”</div>}
              </div>
              <div className={`shrink-0 inline-flex items-center gap-1 text-xs font-semibold rounded-full px-2 py-1 ${r.attending ? "bg-emerald-100 text-emerald-700" : "bg-red-50 text-red-600"}`}>
                {r.attending ? <><Check className="w-3 h-3" /> Yes</> : <><XIcon className="w-3 h-3" /> No</>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RSVPListCard;
